import moment from "moment";
import { ScoringCardsClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component("scoringCardSummary", {
        template: require("./scoringCardSummaryComponent.html"),
        bindings: {},
        controller: [
            AgGridService.componentName,
            angularServicesNames.$translate,
            "$scope",
            ScoringCardsClient.componentName,
            function (
                this: $TSFixMe,
                agGridService: AgGridService,
                $translate: ng.translate.ITranslateService,
                $scope: $TSFixMe,
                apiClient: ScoringCardsClient
            ) {
                var $ctrl = this;

                $ctrl.$onInit = function () {
                    $scope.$watchCollection("$ctrl.filters", () => refreshGrid());
                };

                function refreshGrid() {
                    if (!$ctrl.gridApi) return;

                    $ctrl.gridApi.showLoadingOverlay();
                    apiClient.getSummary().then(items => $ctrl.gridApi.setRowData(items));
                }

                $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

                function compareDateAsDay(filterValue: $TSFixMe, cellValue: $TSFixMe) {
                    const filterMoment = moment(filterValue);
                    const cellMoment = moment(cellValue);
                    if (filterMoment.isSame(cellMoment, "day")) {
                        return 0;
                    } else if (filterMoment.isAfter(cellMoment, "day")) {
                        return -1;
                    } else {
                        return 1;
                    }
                }

                $ctrl.gridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.PROJECT"),
                            field: "projectName",
                            filter: "agTextColumnFilter",
                            rowGroup: true
                        },
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.CREATED_BY"),
                            field: "createdBy",
                            filter: "agSetColumnFilter"
                        },
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.CREATED_TIME"),
                            field: "creationTime",
                            filter: "agDateColumnFilter",
                            valueFormatter: (params: $TSFixMe) => moment(params.value).format("YYYY-MM-DD H:mm:ss"),
                            filterParams: {
                                browserDatePicker: true,
                                comparator: compareDateAsDay
                            }
                        },
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.CURRENCY_CODE"),
                            field: "currencyCode",
                            filter: "agSetColumnFilter"
                        },
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.COUNTRY_CODE"),
                            field: "countryCode",
                            filter: "agSetColumnFilter"
                        },
                        {
                            field: "forecastDateFrom",
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.FROM_DATE"),
                            filter: "agDateColumnFilter",
                            valueFormatter: (params: $TSFixMe) => moment(params.value).format("YYYY-MM-DD"),
                            filterParams: {
                                browserDatePicker: true,
                                comparator: compareDateAsDay
                            }
                        },
                        {
                            field: "forecastDateTo",
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.TO_DATE"),
                            filter: "agDateColumnFilter",
                            valueFormatter: (params: $TSFixMe) => moment(params.value).format("YYYY-MM-DD"),
                            filterParams: {
                                browserDatePicker: true,
                                comparator: compareDateAsDay
                            }
                        },
                        {
                            field: "skuName",
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.SKU"),
                            filter: "agTextColumnFilter"
                        },
                        {
                            field: "productCode",
                            headerValueGetter: () => $translate.instant("CONFIGURATION.SCORING_CARD.PRODUCT_CODE"),
                            filter: "agSetColumnFilter"
                        }
                    ],
                    animateRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true,
                        filterParams: {
                            newRowsAction: "keep"
                        },
                        enableRowGroup: true
                    },
                    floatingFilter: true,
                    suppressMultiSort: true,
                    domLayout: "autoHeight",
                    rowGroupPanelShow: "always",
                    pagination: true,
                    paginationPageSize: 20,
                    groupUseEntireRow: true,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    suppressDragLeaveHidesColumns: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        refreshGrid();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                };
            }
        ]
    });
})(angular.module("topline.modules"));
